import React from "react";

function Spinner({ size = "md", centered = false, fullScreen = false }) {
  const sizeClasses = {
    sm: "w-4 h-4",
    md: "w-8 h-8",
    lg: "w-12 h-12",
    xl: "w-16 h-16",
  };

  const spinner = (
    <div
      className={`${sizeClasses[size]} border-4 border-gray-200 border-t-blue-600 rounded-full animate-spin`}
    />
  );

  if (fullScreen) {
    // Position relative to content area, not full screen
    return (
      <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-75 z-50">
        {spinner}
      </div>
    );
  }

  if (centered) {
    return (
      <div className="flex items-center justify-center min-h-[200px] w-full">
        {spinner}
      </div>
    );
  }

  return spinner;
}

export default Spinner;

